import siteVersionInfo from "../SiteVersionInfo.json";

export default {
  title(state) {
    return state.title;
  },
  isDarkTheme() {
    return this.$vuetify.theme.dark;
  },
  defaultLocale(state) {
    return state.defaultLocale;
  },
  // languages(state) {
  //   return state.languages;
  // },
  siteText(state, getters) {
    return state.languages[getters.selectedLanguage];
  },
  isBusy(state) {
    return state.busy;
  },
  token(state) {
    return state.userSession.authToken.token;
  },
  siteVersion() {
    return siteVersionInfo.VersionNumber;
  },
  baseApiUrl(state) {
    return state.baseApiUrl;
  },
  error(state) {
    return state.error;
  },
};
